import React from 'react';

function TermsContent() {
  return (
    <>
      <p className="legal-date">Ostatnia aktualizacja: 16 marca 2026</p>
      {[
        { title: '§1 Postanowienia ogólne', items: ['Aplikacja VROOM jest udostępniana przez VROOM.APP (dalej: „Operator").', 'Korzystanie z Aplikacji oznacza akceptację niniejszego Regulaminu.', 'Regulamin obowiązuje od dnia 01.01.2026.'] },
        { title: '§2 Rejestracja i konto', items: ['Do korzystania z pełnej funkcjonalności wymagane jest założenie konta.', 'Użytkownik zobowiązuje się podać prawdziwe dane podczas rejestracji.', 'Użytkownik jest odpowiedzialny za bezpieczeństwo swojego hasła.', 'Jedno konto przypisane jest do jednej osoby fizycznej.', 'Operator zastrzega sobie prawo do usunięcia konta naruszającego Regulamin.'] },
        { title: '§3 Zasady korzystania', items: ['Użytkownik zobowiązuje się korzystać z Aplikacji zgodnie z prawem.', 'Zabrania się publikowania treści obraźliwych, podszywania się pod inne osoby, używania botów.'] },
        { title: '§4 Lokalizacja i dane GPS', items: ['Aplikacja korzysta z GPS wyłącznie za zgodą Użytkownika.', 'Użytkownik może wyłączyć lokalizację w ustawieniach w każdej chwili.'] },
        { title: '§5 Treści użytkowników', items: ['Użytkownik może dodawać zdjęcia i opisy (np. Spoty).', 'Operator zastrzega sobie prawo do usunięcia treści naruszających Regulamin.'] },
        { title: '§6 Odpowiedzialność', items: ['Operator nie ponosi odpowiedzialności za treści publikowane przez Użytkowników.', 'Korzystanie z Aplikacji podczas jazdy odbywa się na własne ryzyko Użytkownika.'] },
        { title: '§7 Kontakt', items: ['W sprawach dotyczących Regulaminu: kontakt@v-room.app'] },
      ].map(s => (
        <div key={s.title} className="legal-section">
          <h3>{s.title}</h3>
          {s.items.map((item, i) => <p key={i}>{i + 1}. {item}</p>)}
        </div>
      ))}
    </>
  );
}

function PrivacyContent() {
  return (
    <>
      <p className="legal-date">Ostatnia aktualizacja: 16 marca 2026</p>
      <div className="legal-section">
        <h3>§1 Administrator danych</h3>
        <p>Administratorem danych jest zespół VROOM. Kontakt: <a href="mailto:kontakt@v-room.app">kontakt@v-room.app</a></p>
      </div>
      <div className="legal-section">
        <h3>§2 Jakie dane zbieramy</h3>
        <ul>
          <li><strong>Dane rejestracyjne:</strong> e-mail, nazwa użytkownika, hasło (zaszyfrowane)</li>
          <li><strong>Dane lokalizacyjne:</strong> GPS — tylko za zgodą, tylko gdy aktywna Live Map</li>
          <li><strong>Dane aktywności:</strong> kilometry, odwiedzone miasta, osiągnięcia</li>
          <li><strong>Treści użytkownika:</strong> zdjęcia spotów, komentarze, dane garażu</li>
        </ul>
      </div>
      <div className="legal-section">
        <h3>§3 Cel przetwarzania</h3>
        <ul>
          <li>Świadczenie usług Aplikacji (nawigacja, Live Map, rankingi)</li>
          <li>Wysyłka newslettera (tylko za zgodą)</li>
          <li>Bezpieczeństwo i zapobieganie nadużyciom</li>
        </ul>
      </div>
      <div className="legal-section">
        <h3>§4 Podstawa prawna (RODO)</h3>
        <ul>
          <li>Art. 6 ust. 1 lit. b — wykonanie umowy</li>
          <li>Art. 6 ust. 1 lit. a — zgoda użytkownika</li>
          <li>Art. 6 ust. 1 lit. f — uzasadniony interes (bezpieczeństwo)</li>
        </ul>
      </div>
      <div className="legal-section">
        <h3>§5 Prawa użytkownika</h3>
        <ul>
          <li>Dostęp, sprostowanie i usunięcie danych</li>
          <li>Ograniczenie przetwarzania i przenoszenie danych</li>
          <li>Wniesienie skargi do Prezesa UODO</li>
        </ul>
        <p>Kontakt: <a href="mailto:kontakt@v-room.app">kontakt@v-room.app</a></p>
      </div>
      <div className="legal-section">
        <h3>§6 Bezpieczeństwo</h3>
        <p>Hasła zaszyfrowane (bcrypt). Komunikacja przez HTTPS.</p>
      </div>
      <div className="legal-section">
        <h3>§7 Retencja danych</h3>
        <p>Dane przechowywane przez czas aktywności konta. Po usunięciu kasowane w ciągu 30 dni.</p>
      </div>
    </>
  );
}

export default function LegalModals({ showTerms, showPrivacy, onCloseTerms, onClosePrivacy }) {
  return (
    <>
      {showTerms && (
        <div className="legal-overlay" onClick={onCloseTerms}>
          <div className="legal-modal" onClick={e => e.stopPropagation()}>
            <div className="legal-header">
              <h2>REGULAMIN <span>VROOM</span></h2>
              <button className="legal-close" onClick={onCloseTerms}>
                <span className="material-icons">close</span>
              </button>
            </div>
            <div className="legal-body"><TermsContent /></div>
          </div>
        </div>
      )}

      {showPrivacy && (
        <div className="legal-overlay" onClick={onClosePrivacy}>
          <div className="legal-modal" onClick={e => e.stopPropagation()}>
            <div className="legal-header">
              <h2>POLITYKA <span>PRYWATNOŚCI</span></h2>
              <button className="legal-close" onClick={onClosePrivacy}>
                <span className="material-icons">close</span>
              </button>
            </div>
            <div className="legal-body"><PrivacyContent /></div>
          </div>
        </div>
      )}
    </>
  );
}